// extracted by mini-css-extract-plugin
module.exports = {"box":"box-I9DfLy0U","title":"title-3COsBA8M","date":"date-1ansYN9s","list_top":"list_top-3qsMfh5u","list_middle":"list_middle-3cMkrV53","list_bottom":"list_bottom-1CnKu3hy"};